// extracted by mini-css-extract-plugin
export default {"searchWrapper":"PlayerStats_searchWrapper__CLf-o","containerSearch":"PlayerStats_containerSearch__W2eRI","playerWrapper":"PlayerStats_playerWrapper__3JI25"};